import { makeStyles } from "@mui/styles";
export const useTableStyles = makeStyles(() => ({
  root: {
    width: "100%", 
  },
  container: {
    maxHeight: 600,
  },
}));
